import React from 'react'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { styled } from '@mui/material/styles'
import { Dayjs } from 'dayjs'

interface DateRangePickerProps {
  startDate: Dayjs | null
  endDate: Dayjs | null
  setStartDate: (date: Dayjs | null) => void
  setEndDate: (date: Dayjs | null) => void
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
}) => {
  const handleStartDateChange = (newValue: Dayjs | null) => {
    setStartDate(newValue)
  }

  const handleEndDateChange = (newValue: Dayjs | null) => {
    setEndDate(newValue)
  }

  const CustomDatePickerField = styled(DatePicker)<object>(() => ({
    minHeight: '80px',
    minWidth: '100px',
    color: '#7D7D7D',
    padding: '12px',
    paddingTop: '12px',
    backgroundColor: 'rgb(8,12,20,0.05)',
    borderColor: '#365F91',
    border: '1.2px solid transparent',
    background: `
        linear-gradient(rgb(8, 12, 20), rgb(8, 12, 20)) padding-box,
        linear-gradient(180deg, #365f91 30%, #365f9133 100%) border-box
      `,
    borderImageSlice: 1,
    borderRadius: '40px',
    '& .MuiInputBase-root': {
      pointerEvents: 'auto',
      color: 'white ',
      '&.Mui-focused': {
        border: 'none !important',
        outline: 'none !important',
      },
      '&:focus': {
        boxShadow: 'none',
      },
      '&:hover': {
        boxShadow: 'none',
      },
    },
    '& .MuiInputLabel-root': {
      color: '#7D7D7D !important',
      margin: '12px 0 0 45px',
    },
    '& .MuiFilledInput-root': {
      paddingLeft: '10px',
      paddingRight: '10px',
      color: 'white !important',
    },
    '& .MuiButtonBase-root': {
      color: 'white !important',
      marginBottom: '20px',
    },
  }))

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
        <CustomDatePickerField
          className="bg-white"
          value={startDate}
          onChange={handleStartDateChange}
          format="DD-MM-YYYY"
          label="From"
          slotProps={{
            textField: {
              variant: 'filled',
            },
            inputAdornment: {
              position: 'start',
            },
          }}
        ></CustomDatePickerField>
        <CustomDatePickerField
          value={endDate ? endDate : null}
          className="bg-white"
          onChange={handleEndDateChange}
          label="To"
          format="DD-MM-YYYY"
          slotProps={{
            textField: {
              variant: 'filled',
            },
            inputAdornment: {
              position: 'start',
            },
          }}
        />
      </DemoContainer>
    </LocalizationProvider>
  )
}

export default DateRangePicker
